import { createRequestActionTypes } from "../../../shared/utility";

export const ProductActions = {
    handleProductDetailsFetch: createRequestActionTypes('HANDLE_PRODUCT_DETAILS_FETCH'),
    handleCountryDetailsFetchForProduct: createRequestActionTypes('HANDLE_COUNTRY_DETAILS_FETCH_FOR_PRODUCT'),
    handleBrandDetailsFetchForProduct: createRequestActionTypes('HANDLE_BRAND_DETAILS_FETCH_FOR_PRODUCT'),
    handleCreateOrEditProductSubmit: createRequestActionTypes('HANDLE_CREATE_OR_EDIT_PRODUCT_SUBMIT'),
    fetchMasterProductCategories: createRequestActionTypes('FETCH_MASTER_PRODUCT_CATEGORIES'),
}